import { useEffect } from "react"
import { useOutletContext, useNavigate, useSearchParams } from "react-router-dom"
import { HashLoader } from "react-spinners"

export default function Index() {

    const [ , setPageTitle] = useOutletContext()

    const navigate = useNavigate()
    const [searchParams, ] = useSearchParams()


    useEffect(() => {
        setPageTitle("Accueil")
    }, [setPageTitle])

    useEffect(() => {
        if (searchParams)
            navigate(searchParams.get('redirect_uri') ?? "/forums/")
    }, [navigate, searchParams])


    return (
    <div className="w-full flex flex-col justify-center content-center">
        <HashLoader size={40} cssOverride={{margin: "0 auto 10px auto"}}/>
        <div className="text-center">Aucun contenu a afficher</div>
    </div>
    )
}